import { render, staticRenderFns } from "./ModalReviewsPlans.vue?vue&type=template&id=87997886&scoped=true&"
import script from "./ModalReviewsPlans.vue?vue&type=script&lang=js&"
export * from "./ModalReviewsPlans.vue?vue&type=script&lang=js&"
import style0 from "./ModalReviewsPlans.vue?vue&type=style&index=0&id=87997886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87997886",
  null
  
)

export default component.exports